import { RefObject, useEffect, useState } from 'react';
import { logger } from '@dist-marketplace-frontend/services';

interface IContainerSize {
  width: number;
  height: number;
}

function useContainerSize(ref: RefObject<HTMLElement>) {
  const [containerSize, setContainerSize] = useState<IContainerSize>({
    width: 0,
    height: 0,
  });

  useEffect(() => {
    try {
      function handleResize() {
        if (ref && ref.current) {
          const { width, height } = ref.current.getBoundingClientRect();
          setContainerSize({
            width,
            height,
          });
        }
      }

      window.addEventListener('resize', handleResize);

      handleResize();

      return () => window.removeEventListener('resize', handleResize);
    } catch (e) {
      logger.error({
        error: e,
        message: `Error handling resize `,
        customData: {
          ref,
        },
      });
    }
    // TODO Clean up this effect's dependencies. We're disabling this lint error for now so we can
    // clean up the lint logs. Ideally we should rewrite this code to be less error prone and trust
    // the lint rule's judgement.
    // https://distilledsch.tpondemand.com/RestUI/Board.aspx#page=userstory/98606
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return containerSize;
}

export { useContainerSize };
